module.exports = __webpack_public_path__ + "static/media/atlantix-zen.05d07cf5.jpg";